export const navLinks = [
  { label: "HOME", to: "/" },
  { label: "ABOUT", to: "/about" },
  { label: "SERVICES", to: "/services" },
  { label: "PORTFOLIO", to: "/portfolio" },
  { label: "INSIGHTS", to: "/insights" },
];

export const footerSocials = [
  {
    label: "Facebook",
    icon: "fa-facebook-f",
    href: "https://www.facebook.com/profile.php?id=61579885923446",
  },
  {
    label: "Instagram",
    icon: "fa-instagram",
    href: "https://www.instagram.com/the_biswajit_nandi_studio/",
  },
  {
    label: "LinkedIn",
    icon: "fa-linkedin-in",
    href: "https://www.linkedin.com/in/biswajit-nandi-81766b20b/",
  },
  {
    label: "YouTube",
    icon: "fa-youtube",
    href: "https://www.youtube.com/channel/UCm191fvoyLV7RzjvUS0Dhmg",
  },
];

export const workLogos = [
  { src: "/assets/image/b1.png", alt: "Hostinghub" },
  { src: "/assets/image/b2.png", alt: "Unimax" },
  { src: "/assets/image/b3.png", alt: "Inland Frames" },
  { src: "/assets/image/8.png", alt: "Inland Frames" },
  { src: "/assets/image/torana.png", alt: "Inland Frames" },
  { src: "/assets/image/qylix.png", alt: "Inland Frames" },
  // { src: "/assets/image/mi.png", alt: "Inland " },
  { src: "/assets/image/b4.png", alt: "NestLead" },
];

export const homeServices = [
  {
    title: "Branding & Logo Design",
    description: "Timeless identities that make your brand unforgettable.",
    image: "/assets/image/bl.jpg",
    accent: "B",
  },
  {
    title: "Graphic Design",
    description: "Designs that increase your value and sharpen your message.",
    image: "/assets/image/gd.jpg",
    accent: "G",
  },
  {
    title: "UI/UX Design",
    description: "Beautiful and intuitive experiences for web and mobile.",
    image: "/assets/image/ui.jpg",
    accent: "D",
  },
];

export const aboutParagraphs = [
  "Hello! I'm Biswajit Nandi - a designer, digital artist, and inspiring filmmaker with over 5 years of creative experience.",
  "My creative journey started with a deep curiosity about art and visuals during my school days. After completing my higher secondary at Balangi College, Balasore, I decided to turn my passion into a career and pursued a Diploma in Design from ZICA, Bhubaneswar. This formal education gave me a strong foundation in design principles, color theory, and digital tools.",
  "I began my professional journey at Fotogafik, Chandigarh, where I worked for a year and learned how the design industry functions in real projects. From there, I continued to grow as a freelancer, collaborating with multiple brands and individuals across India and abroad. Each project, whether in UI/UX design, branding, digital art, retouching, or product design, has taught me the importance of creativity, storytelling, and attention to detail.",
  "Later, I joined Lis Co Japan as a Quality Analyst, where I refined my ability to spot details, maintain consistency, and ensure the highest standards of visual work. This mix of freelance freedom and professional discipline has shaped me into a versatile designer.",
  'I am skilled in tools such as Adobe Photoshop, Illustrator, Figma, and other creative suites, which allow me to transform ideas into powerful visuals. But for me, tools are just the medium - the true essence of design lies in creating stories that connect emotionally with people. My design philosophy is simple: "Every frame and every detail should tell a story."',
  "Beyond the world of design, I am an independent filmmaker exploring stories through cinema. I run a YouTube channel, Natamandapa Creation, where I share travel storytelling videos, short films, and creative experiments. For me, filmmaking and design go hand in hand - both are about blending imagination with reality and creating moments that leave an impact.",
];

export const aboutEducation = [
  "🎓 Balangi College, Balasore – Completed Higher Secondary (12th)",
  "🎓 ZICA Bhubaneswar – Diploma in Design (Specialization in Creative Arts & Digital Design)",
];

export const aboutExperience = [
  "Fotogafik, Chandigarh (1 Year) - Worked on branding, graphic design, and digital projects, gaining industry exposure.",
  "Lis Co Japan - QA for creative and digital projects, ensuring quality standards and attention to detail.",
  "Freelancer (4+ Years) - Collaborated with multiple brands and individuals on UI/UX design, branding, retouching, and digital art. Worked on both national and international projects.",
];

export const skillIcons = [
  {
    src: "/assets/image/clade.png",
    alt: "Photo",
    className: "skill-icon-light",
  },
  { src: "/assets/image/photoshop.png", alt: "Photoshop" },
  { src: "/assets/image/figma_5968705.png", alt: "Figma" },
  { src: "/assets/image/premiere-pro_10526868.png", alt: "Premiere Pro" },
  {
    src: "/assets/image/someskill.png",
    alt: "Photoshop Alt",
    className: "skill-icon-invert",
  },
  { src: "/assets/image/chatgpt-logo.webp", alt: "ChatGPT" },
  { src: "/assets/image/after-effects_5968428.png", alt: "After Effects" },
  {
    src: "/assets/image/512px-Adobe_Illustrator_CC_icon.svg.png",
    alt: "Illustrator",
  },
  { src: "/assets/image/maya.png", alt: "Maya" },
];

export const insights = [
  {
    title: "1. Communication is More Important Than Design",
    body: "No matter how good the design is, it fails if the client's vision is not understood. Clear communication saves time, builds trust, and makes the final work more meaningful.",
  },
  {
    title: "2. Every Project Is a Story",
    body: "Whether it is a logo, UI, or digital painting, I treat each project as a story waiting to be told. That mindset keeps the work personal and memorable.",
  },
  {
    title: "3. Tools Are Just Tools",
    body: "Photoshop, Illustrator, and Figma are powerful, but they do not create ideas by themselves. Observation, imagination, and curiosity are what drive real creativity.",
  },
  {
    title: "4. Consistency Builds Your Brand",
    body: "Clients do not only hire skill. They hire reliability. Meeting deadlines, maintaining quality, and staying consistent is what turns one project into long-term trust.",
  },
  {
    title: "5. Growth Comes From Experimentation",
    body: "The biggest learning comes from stepping outside the comfort zone. Mixing filmmaking with design and trying new styles keeps the work fresh.",
  },
];

export const portfolioCategories = [
  { key: "all", label: "All", to: "/portfolio" },
  { key: "graphic", label: "Graphic Design", to: "/portfolio/graphic" },
  { key: "brand", label: "Brand Design", to: "/portfolio/brand" },
  { key: "ui", label: "UI/UX Design", to: "/portfolio/ui" },
  { key: "thumbnail", label: "Thumbnail Design", to: "/portfolio/thumbnail" },
  { key: "digital", label: "Digital Art", to: "/portfolio/digital" },
  { key: "social", label: "Social Media Post", to: "/portfolio/social" },
  { key: "ugc", label: "AD Video", to: "/portfolio/ugc" },
];

export const portfolioContent = {
  all: {
    mode: "mosaic",
    images: [
      "/assets/image/All/image1.jpg",
      "/assets/image/All/image2.jpg",
      "/assets/image/All/image3.jpg",
      "/assets/image/All/image4.jpg",
      "/assets/image/All/aaina.png",
      "/assets/image/All/image6.jpg",
      "/assets/image/All/image7.jpg",
      "/assets/image/All/image8.jpg",
      "/assets/image/All/image9.jpg",
      "/assets/image/All/image10.jpg",
      "/assets/image/All/image11.jpg",
      "/assets/image/All/image12.jpg",
      "/assets/image/All/photoframe.png",
      "/assets/image/All/creamybell.png",
    ],
    extras: [
      "/assets/image/protfolioUi/img1.png",
      "/assets/image/protfolioUi/img2.png",
      "/assets/image/protfolioUi/img3.png",
    ],
  },
  graphic: {
    mode: "columns",
    hero: "/assets/image/protfolioGraphic/img1.jpg",
    columns: [
      [
        "/assets/image/protfolioGraphic/img2.jpg",
        // "/assets/image/protfolioGraphic/img3.jpg",
        "/assets/image/protfolioGraphic/img7.jpg",
      ],
      [
        "/assets/image/protfolioGraphic/img4.jpg",
        "/assets/image/protfolioGraphic/img5.jpg",
      ],
      [
        "/assets/image/protfolioGraphic/img6.jpg",
        "/assets/image/protfolioGraphic/img3.jpg",
      ],
      [
        "/assets/image/protfolioGraphic/img8.jpg",
        "/assets/image/protfolioGraphic/img9.jpg",
      ],
    ],
  },
  brand: {
    mode: "grid",
    images: [
      "/assets/image/naad.png",
      "/assets/image/mic.png",
      "/assets/image/PSD_02.jpg",
      "/assets/image/hosting.png",
      "/assets/image/nata.png",
      "/assets/image/creamybell.png",
      "/assets/image/teeek.png",
      "/assets/image/car.jpg",
      "/assets/image/business-card.jpg",
      "/assets/image/nestlead.jpg",
      "/assets/image/ice-creame-cart.jpg",
      "/assets/image/whatsapp image 2025.jpg",
    ],
  },
  ui: {
    mode: "ui",
    top: [
      "/assets/image/protfolioUi/img1.png",
      "/assets/image/protfolioUi/img2.png",
      "/assets/image/protfolioUi/img3.png",
    ],
    bottom: [
      "/assets/image/protfolioUi/img4.png",
      "/assets/image/protfolioUi/img5.png",
      "/assets/image/protfolioUi/img6.png",
      "/assets/image/proto.png",
    ],
  },
  thumbnail: {
    mode: "grid",
    images: [
      "/assets/image/bikram_glism.jpg",
      "/assets/image/call_of_jaga.jpg",
      "/assets/image/aaina.jpg",
      "/assets/image/overthinker.jpg",
      "/assets/image/biswas_patnayk.jpg",
      "/assets/image/sn_high.jpg",
      "/assets/image/the_lust.jpg",
      "/assets/image/premara_ranga.jpg",
      "/assets/image/from_future_final.jpg",
      "/assets/image/smurti_ranga.jpg",
      "/assets/image/aazadi.jpg",
      "/assets/image/bikram.jpg",
      "/assets/image/starts.jpg",
      "/assets/image/action.png",
      "/assets/image/darpan.png",
    ],
  },
  digital: {
    mode: "grid",
    images: [
      "/assets/image/digitalArt/d.jpg",
      "/assets/image/digitalArt/Ranjan bhai bapa.jpg",
      "/assets/image/digitalArt/sahil.jpg",
      "/assets/image/digitalArt/abhi copy (2).jpg",
      "/assets/image/digitalArt/Caricature 1.jpg",
      "/assets/image/digitalArt/Happy diwali.jpg",
      "/assets/image/digitalArt/ig ganesa.jpg",
      "/assets/image/digitalArt/abisekh 1.jpg",
      "/assets/image/digitalArt/dog.jpg",
      "/assets/image/digitalArt/Dog sketch.jpg",
      "/assets/image/digitalArt/Untitled-1.jpg",
    ],
  },
  social: {
    mode: "grid",
    images: [
      "/assets/image/1.jpg",
      "/assets/image/2.jpg",
      "/assets/image/3.jpg",
      "/assets/image/4.jpg",
      "/assets/image/5.jpg",
      "/assets/image/6.jpg",
    ],
  },
  ugc: {
    mode: "video",
    videos: [
      "/assets/image/myadwb.mp4",
      "/assets/image/ads/clay2.mp4",
      "/assets/image/ads/Astrobharat.mp4",
      "/assets/image/ads/Horror (1).mp4",
      "/assets/image/ads/mantra ad2.mp4",
      "/assets/image/ads/Mantra.mp4",
    ],
  },
};
